jQuery($ => {

    let back_button = document.getElementById('back-button');

    if(back_button){

        const options = {}
        
        // Show back button when header is visible
        const header_observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {                
                if(entry.isIntersecting){
                back_button.classList.remove('hidden');
                }else{
                    back_button.classList.add('hidden');
                }
            })
        }, options)
        header_observer.observe(document.getElementById("masthead"));


        // Show back button when footer is visible
        const footer_observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                back_button.classList.remove('hidden');
                }else{
                    back_button.classList.add('hidden');
                }
            })
        }, options)
        footer_observer.observe(document.getElementById("footer"));

    }

});